import type { PropertyGroupResponse, UpsertPropertyGroupRequest } from '@/shared/api';

/** Was eine Karte ändern darf. Alles andere schickt die Anfrage unverändert oder gar nicht. */
export type ObjectPatch = Partial<
  Pick<
    UpsertPropertyGroupRequest,
    | 'name'
    | 'address'
    | 'needsAddressReview'
    | 'checkInTime'
    | 'checkOutTime'
    | 'buildingAccessCode'
    | 'houseRulesDe'
    | 'houseRulesEn'
  >
>;

/**
 * Die Speicheranfrage einer einzelnen Karte. Name, Adresse, Währung und Zeitzone verlangt der
 * Vertrag immer und kommen unverändert aus dem geladenen Objekt; Zeiten, Haustürcode und
 * Hausordnung fehlen, wenn die Karte sie nicht ändert — fehlend heißt dort „unverändert", ein
 * leerer Haustürcode dagegen „löschen". So kann keine Karte fremde Felder überschreiben.
 */
export function objectUpdateRequest(
  group: PropertyGroupResponse,
  patch: ObjectPatch,
): UpsertPropertyGroupRequest {
  const { address } = group;
  return {
    name: group.name,
    address: {
      street: address.street,
      streetName: address.streetName,
      houseNumber: address.houseNumber,
      postalCode: address.postalCode,
      city: address.city,
      countryCode: address.countryCode,
      latitude: address.latitude,
      longitude: address.longitude,
    },
    needsAddressReview: group.needsAddressReview,
    currency: group.currency,
    timezone: group.timezone,
    ...patch,
  };
}
